<!-- 对话框 -->
<template>
  <el-dialog
    :title="title"
    :width="width"
    :model-value="modelValue"
    :append-to-body="appendToBody"
    @close="handleClosed"
  >
    <slot name="content"></slot>
    <template #footer>
      <div class="dialog-footer">
        <slot name="extendBtn"></slot>
        <el-button v-if="showClosed" @click="handleClosed">{{
          closedText
        }}</el-button>
        <el-button v-if="showConfirm" type="primary" @click="onConfirm">{{
          confirmText
        }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
const props = defineProps({
  // 标题
  title: {
    type: String,
    default: "",
  },
  // v-model 绑定的值，是否显示对话框
  modelValue: {
    required: true,
    type: Boolean,
  },
  // 对话框宽度
  width: {
    required: false,
    type: String,
    default: "500px",
  },
  appendToBody: {
    type: Boolean,
    default: false,
  },
  // 是否显示确定按钮
  showConfirm: {
    type: Boolean,
    default: true,
  },
  confirmText: {
    type: String,
    default: "确 定",
  },
  // 是否显示取消按钮
  showClosed: {
    type: Boolean,
    default: true,
  },
  closedText: {
    type: String,
    default: "取 消",
  },
});

const emits = defineEmits(["update:modelValue", "onConfirm", "onClosed"]);
// 关闭
const handleClosed = () => {
  emits("update:modelValue", false);
  emits("onClosed");
};

// 提交
const onConfirm = () => {
  emits("onConfirm");
};
</script>

<style lang="scss" scoped></style>
